/**
  * @author Ryan Gladstone, Brendan Magee
  */

function groupsService($http, $q, $translate, cacheService) {
  const service = {
    directory: {}
  };

  service.getGroups = () => (
    $http.get('api/groups', { cache: true })
      .then(({ data }) => {
        const groups = Array.isArray(data) ? data : [];
        return groups
          .map((group) => {
            const groupWebsite = group.website || $translate.instant('MULTISITE.ALL_WEBSITES');
            const displayName = `${group.name} (${groupWebsite})`;
            service.directory[group.id] = displayName;
            return {
              displayName,
              name: group.name,
              website: group.website,
              id: group.id
            };
          });
      }));

  service.getGroup = (groupId) => {
    const deferred = $q.defer();

    $http.get(`api/groups/${groupId}`)
      .then((response) => {
        deferred.resolve(response.data);
      }, (response) => {
        deferred.reject(response);
      });

    return deferred.promise;
  };

  service.createGroup = (group) => {
    const deferred = $q.defer();

    $http.post('api/groups', group)
      .then((response) => {
        cacheService.invalidateCache('groups');
        deferred.resolve(response.data);
      }, (response) => {
        deferred.reject(response);
      });

    return deferred.promise;
  };

  service.deleteGroup = (groupId) => {
    const deferred = $q.defer();

    $http.delete(`api/groups/${groupId}`)
      .then((response) => {
        cacheService.invalidateCache('groups');
        deferred.resolve(response.data);
      }, (response) => {
        deferred.reject(response);
      });

    return deferred.promise;
  };

  service.updateGroup = (groupId, update) => {
    const deferred = $q.defer();

    $http.put(`api/groups/${groupId}`, update)
      .then((response) => {
        cacheService.invalidateCache('groups');
        cacheService.invalidateCache(`groups/${groupId}`);
        deferred.resolve(response.data);
      }, (response) => {
        deferred.reject(response);
      });

    return deferred.promise;
  };

  service.convertIdToName = (groupId) => {
    const deferred = $q.defer();

    service.getGroups()
      .then(() => {
        if (angular.isDefined(service.directory[groupId])) {
          deferred.resolve(service.directory[groupId]);
        } else {
          const unknownGroup = $translate.instant('UNKNOWN_GROUP');
          deferred.resolve(`${unknownGroup} #${groupId}`);
        }
      }, (response) => {
        deferred.reject(response);
      });

    return deferred.promise;
  };

  return service;
}

const arr = [
  '$http',
  '$q',
  '$translate',
  'cacheService',
  groupsService
];

module.exports = (ngModule) => {
  ngModule.service('groupsService', arr);
};
